/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { useEffect, useState } from 'preact/compat';
import { events } from '@adobe-commerce/event-bus';
import { NegotiableQuoteModel } from '@/quote-management/data/models';

/**
 * Custom hook to manage quote summary data and loading state
 */
export const useQuoteSummaryData = () => {
  const [quoteData, setQuoteData] = useState<NegotiableQuoteModel | undefined>(
    undefined
  );
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const quoteDataEvent = events.on(
      'quote-management/quote-data',
      (payload: { quote: NegotiableQuoteModel }) => {
        const { quote } = payload;
        if (quote) {
          setQuoteData(quote);
          setLoading(false);
        }
      },
      {
        eager: true,
      }
    );
    return () => quoteDataEvent?.off();
  }, []);

  return {
    quoteData,
    loading,
  };
};

